module.exports = __webpack_public_path__ + "static/media/img-tag-moduleD1.a4aebbb8.png";